module.exports = __webpack_public_path__ + "fonts/400-normal-greek-ext.7f5641a.woff2";